/**
 * Open a RevOps HTML document (pricing guide, client proposal) in a new tab.
 * The endpoints need the operator's auth headers, so the page is fetched and
 * opened from a blob URL; print or save it as PDF from the browser.
 */

const PLATFORM_BACKEND_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_PLATFORM_API_URL) ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_WEAVEIN_API_URL) ||
  'https://weavein-api.onrender.com';

function headers(): Record<string, string> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('auth_token') : null;
  const cboId = typeof window !== 'undefined' ? localStorage.getItem('active_cbo_id') : null;
  const tenantSlug = typeof window !== 'undefined' ? localStorage.getItem('platform_tenant_slug') : null;
  const h: Record<string, string> = {};
  if (token) h['Authorization'] = `Bearer ${token}`;
  if (cboId) h['X-CBO-ID'] = cboId;
  if (tenantSlug) h['X-Tenant-ID'] = tenantSlug;
  return h;
}

export async function openRevopsDocument(path: string): Promise<void> {
  // Open the tab synchronously (inside the click) so popup blockers allow it.
  const tab = window.open('', '_blank');
  const res = await fetch(`${PLATFORM_BACKEND_URL}/api/platform/v1/revops${path}`, { headers: headers() });
  if (!res.ok) {
    tab?.close();
    const detail = (await res.json().catch(() => ({})))?.detail;
    throw new Error(detail || `Could not open the document (${res.status})`);
  }
  const url = URL.createObjectURL(new Blob([await res.text()], { type: 'text/html' }));
  if (tab) tab.location.href = url;
  else window.location.assign(url);
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
